import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, exhaustMap, mergeMap, withLatestFrom} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {EMPTY, of,} from 'rxjs';
import {FaxeStore} from '@app/store/faxe/faxe-store-model';
import {onOperationStatus} from '@app/store/client-slices/operation/operation.actions';
import { isNotEmpty, push } from '@app/fremework/functions';
import { addManyRaces, fetchAllRaces, getRaces } from '@app/store/faxe/race/race.actions';
import { selectRaceAll } from '@app/store/faxe/race/race.selectos';
import { RacesService } from '@app/rest-client/faxe/services/races.service';

@Injectable()
export class RaceEffects {

  fetchRaceEffect = createEffect(() => this.actions$.pipe(
    ofType(fetchAllRaces),
    withLatestFrom(this.store.select(selectRaceAll)),
    exhaustMap(([action, state]) => {

      if (isNotEmpty(state)) {
        return EMPTY;
      }

      const actions = [];
      actions.push(getRaces({
        issuerStack: push(action.issuerStack,'fetchRaceEffect')
      }));
      return of(...actions);
    }),
    catchError(() => EMPTY)
    )
  );

  getRaceEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(getRaces),
      exhaustMap((action) => this.service.races()
        .pipe(mergeMap((response) => {
            const actions = [];
            actions.push(addManyRaces(
              {models: response, issuerStack: push(action.issuerStack,'getRaceEffect')}));
            return of(...actions);
          }),
          catchError((e) =>
            of(onOperationStatus({model: {
                status: e.status,
                operationId:'races',
                callStack: push(action.issuerStack, 'races')}}))
          )
        )),
      catchError(() => EMPTY)
    )
  );

  constructor(
    private service: RacesService,
    private actions$: Actions,
    private store: Store<FaxeStore>,
  ) {
  }
}
